(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["woolique-collection-atmosphere"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wq-collection-atmosphere')) {
    customElements.define('wq-collection-atmosphere', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.slides = Array.from(this.querySelectorAll('[data-atmosphere-slide]'));
        this.nextButton = this.querySelector('[data-atmosphere-next]');
        this.transitionLocked = false;
        if (this.nextButton && this.slides.length > 1) {
          this.nextButton.hidden = false;
          this.nextButton.addEventListener('click', () => {
            clearTimeout(this.timer);
            if (!this.busy && !this.transitionLocked) this.advance(true);
            else this.schedule();
          }, { signal });
        }
        this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.suspended = false;
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        }, { threshold: 0.05 });
        this.observer.observe(this);
        this.reduced.addEventListener('change', () => this.schedule(), { signal });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        window.addEventListener('pagehide', () => { this.suspended = true; this.schedule(); }, { signal });
        window.addEventListener('pageshow', () => { this.suspended = false; this.schedule(); }, { signal });
        this.addEventListener('focusin', () => this.schedule(), { signal });
        this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), { signal });
        this.prepare(this.index);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.releaseTimer);
        this.transitionLocked = false;
        this.nextButton?.removeAttribute('aria-disabled');
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }
      canAdvance() {
        const focused = document.activeElement;
        const focusPauses = this.contains(focused) && (focused !== this.nextButton || focused.matches(':focus-visible'));
        return this.isConnected && this.slides.length > 1 && this.visible && !this.suspended && !document.hidden && !this.reduced.matches && !focusPauses;
      }
      canShow(manual) {
        return manual ? this.isConnected && this.slides.length > 1 && !this.suspended && !document.hidden : this.canAdvance();
      }
      prepare(index) {
        const slide = this.slides[index];
        if (!slide) return Promise.resolve(false);
        if (slide.ready) return slide.ready;
        const template = slide.querySelector('template');
        if (template) template.replaceWith(template.content.cloneNode(true));
        const image = slide.querySelector('img');
        slide.ready = new Promise(resolve => {
          if (!image) return resolve(false);
          const finish = async () => {
            if (!image.naturalWidth) return resolve(false);
            try { await image.decode(); } catch {}
            resolve(image.naturalWidth > 0);
          };
          if (image.complete) finish();
          else {
            image.addEventListener('load', finish, { once: true });
            image.addEventListener('error', () => resolve(false), { once: true });
          }
        });
        return slide.ready;
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.canAdvance()) return;
        this.prepare((this.index + 1) % this.slides.length);
        this.timer = setTimeout(() => this.advance(), 5000);
      }
      async advance(manual = false) {
        if (!this.canShow(manual) || this.busy || this.transitionLocked) return;
        this.busy = true;
        this.nextButton?.setAttribute('aria-disabled', 'true');
        try {
          for (let step = 1; step < this.slides.length; step++) {
            const next = (this.index + step) % this.slides.length;
            const ready = await this.prepare(next);
            if (!this.canShow(manual)) return;
            if (!ready) continue;
            const previous = this.slides[this.index], current = this.slides[next];
            previous.classList.remove('is-active');
            previous.inert = true;
            previous.setAttribute('aria-hidden', 'true');
            current.inert = false;
            current.removeAttribute('aria-hidden');
            current.classList.add('is-active');
            this.index = next;
            if (!this.reduced.matches) {
              this.transitionLocked = true;
              this.releaseTimer = setTimeout(() => {
                this.transitionLocked = false;
                this.nextButton?.removeAttribute('aria-disabled');
              }, 1150);
            }
            break;
          }
        } finally {
          this.busy = false;
          if (!this.transitionLocked) this.nextButton?.removeAttribute('aria-disabled');
          if (this.controller) this.schedule();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["woolique-demand-components"] && !Shopify.designMode) return;
  try {
    (() => {
    const pending = new Map();
    document.querySelectorAll('template[data-wq-component]').forEach(template => {
      const selector = template.dataset.wqComponent;
      const script = template.content.querySelector('script[type="module"][src]');
      if (selector && script) pending.set(selector, { url: script.src, loading: false });
    });
    if (!pending.size) return;
    let observer;
    const scan = root => {
      for (const [selector, entry] of pending) {
        if (entry.loading || !(root.matches?.(selector) || root.querySelector?.(selector))) continue;
        entry.loading = true;
        import(entry.url).then(() => {
          pending.delete(selector);
          if (!pending.size) observer?.disconnect();
        }).catch(error => {
          entry.loading = false;
          console.error('Unable to load theme component:', selector, error);
        });
      }
    };
    observer = new MutationObserver(records => {
      for (const record of records) {
        for (const node of record.addedNodes) if (node.nodeType === Node.ELEMENT_NODE) scan(node);
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    scan(document);
    document.addEventListener('shopify:section:load', event => scan(event.target));
    window.addEventListener('pageshow', () => scan(document));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["woolique-editorial-motion"] && !Shopify.designMode) return;
  try {
    (() => {
    window.WooliqueEditorialMotion?.destroy();
    const scope = 'body.wq-draft';
    const revealSelector = [
      '.wq-way-intro', '.wq-editorial-tile', '.wq-section-head', '.wq-product-card', '.wq-journal-list > a',
      '.wq-catalogue__photo', '.wq-catalogue__copy', '.wq-catalogue__closing',
      '.wq-collection-index__image', '.wq-collection-index__row > div',
      '.wqj__image-link', '.wqj__story-copy', '.wqj__bookend',
      '.wqa__cover', '.wqa__content h2', '.wqa__content h3', '.wqa__endnotes',
      '.wl-brand__story-heading', '.wl-brand__study', '.wl-brand__closing > h2', '.wl-brand__closing > p',
      '.wq-page__answer', '.wq-page__guide-heading', '.wq-page__steps > li',
      '.wq-page__contact-intro > div:not(.wq-page__contact-original)',
      '.wq-page__body:not(.wq-page__body--faq) > h2', '.wq-page__body:not(.wq-page__body--faq) > h3',
      '.wlp-product__details-heading', '.wlp-product__description > h2', '.wlp-product__description > h3',
      '.wq-product-story__scene', '.wq-product-story__narrative > :is(p,h2)', '.wq-product-story__feature', '.wq-product-story__note', '.wq-product-story__original', '.wq-product-story__help',
      '.wq-search-result', '.shopify-policy__body h2', '.shopify-policy__body h3',
      '.wl-footer__newsletter-copy', '.wl-footer__brand', '.wl-footer__desktop-menus > .wl-footer__menu', '.wl-footer__accordion'
    ].join(',');
    const introSelector = [
      '.wq-hero-copy > p', '.wq-hero-links',
      '.wq-catalogue__intro-inner > div:first-child > :not(h1)',
      '.wq-collection-index > header > :not(h1)',
      '.wq-page__introduction > :not(h1)', '.wl-brand__intro > :not(h1)',
      '.wqj__masthead-inner > div > :not(h1)', '.wqj__intro',
      '.wqa__header > :not(h1)', '.wq-recovery__copy > :not(h1)',
      '.wq-search-heading__intro > :not(h1)'
    ].join(',');
    const allRevealSelector = `${revealSelector},${introSelector}`;
    const pictureSelector = '.wq-catalogue__photo, .wq-collection-index__image, .wqj__image-link, .wl-brand__study, .wq-product-story__scene, .wq-product-story__original';
    const panelSelector = '.wq-shop-menu, .wq-mobile-menu, .wq-page__answer, .wq-product-story__disclosure, .wl-brand__about, .wl-footer__accordion';
    const panelContentSelector = '.wq-shop-panel, .wq-mobile-panel, .wq-page__answer-content, .wq-product-story__spec-copy, .wl-brand__original, .wl-footer__accordion-links';
    const liftSelector = '.wqj__read-link, .wq-catalogue__link, .wq-collection-index__link, .wq-text-link, .wl-brand__continue, .wq-page__text-link, .wqa__journal-link, .wqa__text-link, .wq-recovery__links a, .wq-product-story__text-link';
    const imageHoverSelector = '.wq-catalogue__photo, .wq-collection-index__image, .wqj__image-link, .wq-search-result__image, .wq-editorial-tile, .wq-product-card > a';
    const arrowSelector = '.wq-inline-icon, .wqj__icon, .wqa__icon, .wq-page__arrow, .wq-catalogue__link > span[aria-hidden], .wq-collection-index__link > span[aria-hidden], .wq-recovery__arrow, .wq-product-story__text-link > span[aria-hidden]';
    const excluded = 'form, dialog, [hidden], [inert], [aria-hidden="true"]:not(.wqj__image-link), .wlp-product__media, .wlp-product__info, .wq-page__index, .cart-page, [data-wq-motion-exclude]';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const supported = typeof window.IntersectionObserver === 'function' && typeof Element.prototype.animate === 'function';
    const listeners = new AbortController();
    const observers = new Map();
    const watched = new Map();
    const active = new Map();
    const seen = new WeakSet();
    const panels = new WeakSet();
    const played = { entrance: 0, intro: 0, panel: 0 };
    let mutationObserver;
    let frame = 0;
    let resizeTimer = 0;
    let suspended = false;
    let destroyed = false;

    function visible(element) {
      if (!element.isConnected || element.closest(excluded)) return false;
      const closed = element.closest('details:not([open])');
      if (closed && closed !== element && !closed.querySelector('summary')?.contains(element)) return false;
      const rect = element.getBoundingClientRect();
      const style = getComputedStyle(element);
      return rect.width > 0 && rect.height > 0 && style.visibility === 'visible' && style.display !== 'none' && Number(style.opacity) > 0;
    }

    function scrollRoot(element) {
      const wrapper = element.closest('.page-wrapper');
      if (!wrapper || !/(auto|scroll)/.test(getComputedStyle(wrapper).overflowY)) return null;
      return wrapper.clientHeight > 0 ? wrapper : null;
    }

    function viewport(root) {
      return root ? root.getBoundingClientRect() : { top: 0, bottom: window.innerHeight };
    }

    function stop(element, state = 'complete') {
      const animation = active.get(element);
      active.delete(element);
      if (animation) animation.cancel();
      element.dataset.wqMotionState = state;
    }

    function forget(element) {
      watched.get(element)?.unobserve(element);
      watched.delete(element);
    }

    function play(element, kind, delay = 0) {
      if (destroyed || suspended || document.hidden || reduced.matches || !visible(element) || element.contains(document.activeElement)) return;
      const style = getComputedStyle(element);
      if (style.animationName !== 'none' || style.transform !== 'none' || (style.translate && style.translate !== 'none')) return;
      try {
        stop(element);
        const isPicture = element.matches(pictureSelector);
        const desktop = window.matchMedia('(min-width: 750px)').matches;
        const journalImage = kind === 'entrance' && element.matches('.wqj__story > .wqj__image-link');
        const journalCopy = kind === 'entrance' && element.matches('.wqj__story > .wqj__story-copy');
        const journalEntrance = journalImage || journalCopy;
        const journalDistance = desktop ? Math.min(64, window.innerWidth * .04) : 20;
        const start = journalEntrance ? `${journalImage ? -journalDistance : journalDistance}px 0` : kind === 'panel' ? '0 -6px' : kind === 'intro' ? '0 10px' : isPicture && desktop ? '12px 22px' : '0 18px';
        const frames = [{ translate: start, opacity: journalEntrance ? .15 : kind === 'intro' ? 1 : .9 }, { translate: '0 0', opacity: 1 }];
        const duration = journalEntrance ? (desktop ? 1000 : 820) : kind === 'panel' ? 260 : isPicture ? 860 : 680;
        const easing = journalEntrance ? 'cubic-bezier(.22,.7,.2,1)' : 'cubic-bezier(.16,1,.3,1)';
        const animation = element.animate(frames, { duration, delay: Math.min(delay, 180), easing, fill: delay ? 'backwards' : 'none' });
        active.set(element, animation);
        played[kind] += 1;
        element.dataset.wqMotionState = 'running';
        element.dataset.wqMotionKind = kind;
        animation.onfinish = () => {
          if (active.get(element) === animation) { active.delete(element); element.dataset.wqMotionState = 'complete'; }
        };
        animation.oncancel = () => {
          if (active.get(element) === animation) { active.delete(element); element.dataset.wqMotionState = 'complete'; }
        };
      } catch {
        element.dataset.wqMotionState = 'static';
      }
    }

    function observerFor(root) {
      if (!observers.has(root)) {
        const observer = new IntersectionObserver(entries => {
          const groups = new Map();
          entries.forEach(entry => {
            if (scrollRoot(entry.target) !== root) { forget(entry.target); schedule(); return; }
            if (!entry.isIntersecting || entry.intersectionRect.width <= 0 || entry.intersectionRect.height <= 0 || !visible(entry.target)) return;
            const rect = entry.target.getBoundingClientRect();
            if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
            forget(entry.target);
            seen.add(entry.target);
            entry.target.dataset.wqMotionState = 'complete';
            const group = entry.target.parentElement;
            const position = groups.get(group) || 0;
            groups.set(group, position + 1);
            play(entry.target, 'entrance', position * 85);
          });
        }, { root, rootMargin: '0px 0px -24px 0px', threshold: .06 });
        observers.set(root, observer);
      }
      return observers.get(root);
    }

    function enhanceHover(container) {
      container.querySelectorAll(imageHoverSelector).forEach(element => { element.dataset.wqMotionHover = 'image'; });
      container.querySelectorAll(liftSelector).forEach(element => { element.dataset.wqMotionHover = 'lift'; });
      container.querySelectorAll('.wlp-product__add').forEach(element => { element.dataset.wqMotionPress = ''; });
      container.querySelectorAll(panelSelector).forEach(element => panels.add(element));
      container.querySelectorAll(arrowSelector).forEach(element => {
        if (element.closest('a') && !element.closest('form')) {
          element.dataset.wqMotionArrow = element.matches('.wqj__icon--previous, .wqa__icon--previous') ? 'previous' : element.matches('.wq-page__arrow--down') ? 'down' : 'next';
        }
      });
    }

    function scan() {
      frame = 0;
      if (destroyed || suspended) return;
      const container = document.querySelector(scope);
      if (!container) return;
      enhanceHover(container);
      if (!supported || reduced.matches) return;
      for (const [root, observer] of observers) if (root && !root.isConnected) { observer.disconnect(); observers.delete(root); }
      for (const element of watched.keys()) if (!element.isConnected) forget(element);
      for (const element of active.keys()) if (!element.isConnected) stop(element);
      const introGroups = new Map();
      container.querySelectorAll(allRevealSelector).forEach(element => {
        if (seen.has(element) || watched.has(element) || !visible(element)) return;
        if (element.parentElement.closest(revealSelector)) return;
        const root = scrollRoot(element);
        const bounds = viewport(root);
        const rect = element.getBoundingClientRect();
        if (rect.top < bounds.bottom || element.contains(document.activeElement)) {
          seen.add(element);
          element.dataset.wqMotionState = 'static';
          if (element.matches(introSelector) && rect.bottom > bounds.top && !element.contains(document.activeElement)) {
            const group = element.parentElement;
            const position = introGroups.get(group) || 0;
            introGroups.set(group, position + 1);
            play(element, 'intro', position * 70);
          }
          return;
        }
        const observer = observerFor(root);
        watched.set(element, observer);
        element.dataset.wqMotionState = 'pending';
        element.dataset.wqMotionRoot = root ? 'page-wrapper' : 'viewport';
        observer.observe(element);
      });
    }

    function schedule() {
      if (!frame && !destroyed && !suspended) frame = requestAnimationFrame(scan);
    }

    function clearObservers() {
      observers.forEach(observer => observer.disconnect());
      observers.clear();
      watched.forEach((observer, element) => { element.dataset.wqMotionState = 'static'; });
      watched.clear();
    }

    function pause() {
      cancelAnimationFrame(frame);
      frame = 0;
      clearTimeout(resizeTimer);
      clearObservers();
      for (const element of active.keys()) stop(element, 'static');
      mutationObserver?.disconnect();
      mutationObserver = null;
    }

    function start() {
      if (destroyed) return;
      if (document.hidden) { suspended = true; pause(); return; }
      suspended = false;
      document.documentElement.dataset.wqMotion = reduced.matches || !supported ? 'static' : 'ready';
      if (!reduced.matches && supported && !mutationObserver && document.body) {
        mutationObserver = new MutationObserver(records => {
          const relevant = records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('main, .shopify-section, .page-wrapper') || node.matches(allRevealSelector) || node.querySelector(allRevealSelector))));
          if (relevant) schedule();
        });
        mutationObserver.observe(document.body, { childList: true, subtree: true });
      }
      schedule();
    }

    function onPreference() { pause(); start(); }
    function onResize() { clearTimeout(resizeTimer); resizeTimer = setTimeout(() => { clearObservers(); schedule(); }, 120); }
    function onFocus(event) {
      for (const element of active.keys()) if (element.contains(event.target)) stop(element);
      for (const element of watched.keys()) if (element.contains(event.target)) { forget(element); seen.add(element); element.dataset.wqMotionState = 'static'; }
    }
    function onToggle(event) {
      const detail = event.target;
      if (!(detail instanceof Element) || !detail.matches(panelSelector) || !detail.closest(scope)) return;
      if (!panels.has(detail)) { panels.add(detail); schedule(); return; }
      const content = detail.querySelector(panelContentSelector);
      if (content) {
        if (detail.open) play(content, 'panel');
        else stop(content, 'static');
      }
      schedule();
    }
    function onUnload(event) {
      for (const element of active.keys()) if (event.target.contains(element)) stop(element);
      for (const element of watched.keys()) if (event.target.contains(element)) forget(element);
    }
    function onSelect(event) {
      for (const element of active.keys()) if (event.target.contains(element) || element.contains(event.target)) stop(element, 'static');
      for (const element of watched.keys()) if (event.target.contains(element) || element.contains(event.target)) { forget(element); seen.add(element); element.dataset.wqMotionState = 'static'; }
    }
    function destroy() {
      destroyed = true;
      pause();
      listeners.abort();
      delete document.documentElement.dataset.wqMotion;
    }

    reduced.addEventListener('change', onPreference, { signal: listeners.signal });
    window.addEventListener('resize', onResize, { passive: true, signal: listeners.signal });
    window.addEventListener('pagehide', () => { suspended = true; pause(); }, { signal: listeners.signal });
    window.addEventListener('pageshow', start, { signal: listeners.signal });
    window.addEventListener('popstate', schedule, { signal: listeners.signal });
    document.addEventListener('shopify:section:load', start, { signal: listeners.signal });
    document.addEventListener('shopify:section:unload', onUnload, { signal: listeners.signal });
    document.addEventListener('shopify:section:select', onSelect, { signal: listeners.signal });
    document.addEventListener('shopify:block:select', onSelect, { signal: listeners.signal });
    document.addEventListener('focusin', onFocus, { signal: listeners.signal });
    document.addEventListener('pointerdown', onFocus, { passive: true, signal: listeners.signal });
    document.addEventListener('toggle', onToggle, { capture: true, signal: listeners.signal });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) { suspended = true; pause(); }
      else start();
    }, { signal: listeners.signal });
    window.WooliqueEditorialMotion = { destroy, refresh: schedule, diagnostics: () => ({ version: '2.0', supported, reduced: reduced.matches, suspended, observed: watched.size, active: active.size, roots: observers.size, played: { ...played } }) };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true, signal: listeners.signal });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["woolique-english-validation"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('woolique-validation-messages');
  if (!config || config.dataset.initialized) return;
  config.dataset.initialized = 'true';
  const messages = JSON.parse(config.textContent);
  const owned = new WeakMap();
  const isField = (field) => field instanceof HTMLInputElement ||
    field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement;
  const message = (key, values = {}) => Object.entries(values).reduce(
    (text, [name, value]) => text.replaceAll('[' + name + ']', String(value)),
    messages[key] || messages.invalid
  );
  const clearOwned = (field) => {
    const previous = owned.get(field);
    if (!previous) return;
    if (!field.willValidate && field.validity.customError) return;
    if (field.validationMessage === previous) field.setCustomValidity('');
    owned.delete(field);
  };
  const clearGroup = (field) => {
    if (!isField(field)) return;
    clearOwned(field);
    if (field.type !== 'radio' || !field.name) return;
    const group = field.form ? field.form.elements : document.querySelectorAll('input[type="radio"]');
    for (const member of group) {
      if (member.type === 'radio' && member.name === field.name && member.form === field.form) {
        clearOwned(member);
      }
    }
  };
  const getMessage = (field) => {
    const validity = field.validity;
    const type = field.type;
    if (validity.badInput) {
      if (type === 'number') return message('number');
      if (type === 'date' || type === 'month' || type === 'week') return message('date');
      if (type === 'time') return message('time');
      if (type === 'datetime-local') return message('date_time');
      return message('invalid');
    }
    if (validity.valueMissing) {
      if (type === 'email') return message('email_required');
      if (type === 'checkbox') return message('checkbox');
      if (type === 'radio' || field instanceof HTMLSelectElement) return message('select');
      if (type === 'file') return message('file');
      return message('required');
    }
    if (validity.typeMismatch) {
      if (type === 'email') return message(field.multiple ? 'email_multiple' : 'email');
      if (type === 'url') return message('url');
      return message('invalid');
    }
    if (validity.tooShort) return message('too_short', { min: field.minLength });
    if (validity.tooLong) return message('too_long', { max: field.maxLength });
    if (validity.rangeUnderflow || validity.rangeOverflow) {
      const bound = validity.rangeUnderflow ? 'min' : 'max';
      const prefix = type === 'date' ? 'date_' : type === 'time' ? 'time_' : 'range_';
      return message(prefix + bound, { [bound]: field[bound] });
    }
    if (validity.patternMismatch) return message('pattern');
    if (validity.stepMismatch) {
      if (type !== 'number' && type !== 'range') return message('invalid');
      const numericAttribute = (name) => {
        const value = field.getAttribute(name);
        return value !== null && value.trim() !== '' && Number.isFinite(Number(value)) ? Number(value) : null;
      };
      const step = numericAttribute('step');
      const base = numericAttribute('min') ?? numericAttribute('value') ?? 0;
      return message('step', { step: step !== null && step > 0 ? step : 1, base });
    }
    return validity.valid ? '' : message('invalid');
  };
  document.addEventListener('invalid', (event) => {
    const field = event.target;
    if (!isField(field) || !field.willValidate || field.closest('[data-woolique-validation="off"]')) return;
    clearOwned(field);
    if (field.validity.customError) return;
    const text = getMessage(field);
    if (!text) return;
    field.setCustomValidity(text);
    owned.set(field, field.validationMessage);
  }, true);
  for (const eventName of ['input', 'change']) {
    document.addEventListener(eventName, (event) => clearGroup(event.target), true);
  }
  document.addEventListener('reset', (event) => {
    if (!(event.target instanceof HTMLFormElement)) return;
    for (const field of event.target.elements) clearOwned(field);
  }, true);
  document.addEventListener('quantity-selector:update', (event) => {
    if (!(event.target instanceof Element)) return;
    for (const field of event.target.querySelectorAll('input[type="number"]')) clearOwned(field);
  }, true);
  new MutationObserver((records) => {
    for (const record of records) {
      if (isField(record.target)) clearOwned(record.target);
    }
  }).observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['min', 'max', 'step', 'value', 'required', 'pattern', 'minlength', 'maxlength', 'multiple', 'disabled', 'readonly', 'data-cart-quantity']
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["woolique-home-storage-details"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-wq-storage-details]';
    if (window.WqHomeStorageDetails) {
      window.WqHomeStorageDetails.init(document);
      return;
    }
    const instances = new Map();
    const mount = (root) => {
      if (instances.has(root)) return;
      const features = Array.from(root.querySelectorAll('[data-wq-storage-feature]'));
      const points = Array.from(root.querySelectorAll('[data-wq-storage-point]'));
      const announcements = Array.from(root.querySelectorAll('[data-wq-storage-announcement]'));
      const popover = root.querySelector('[data-wq-storage-popover]');
      const popoverContents = Array.from(root.querySelectorAll('[data-wq-storage-popover-content]'));
      const mobile = window.matchMedia('(max-width: 749px)');
      const desktopControls = points.map((point) => point.getAttribute('aria-controls'));
      let popupIndex = null;
      if (!features.length) return;
      const controller = new AbortController();
      const sync = () => {
        points.forEach((point, index) => {
          const detail = features[Number(point.dataset.wqStoragePoint)];
          point.setAttribute('aria-expanded', String(mobile.matches ? popupIndex === index : Boolean(detail && detail.open)));
          point.setAttribute('aria-controls', mobile.matches && popover ? popover.id : desktopControls[index]);
        });
      };
      const closePopover = (restoreFocus = false) => {
        const previous = popupIndex;
        popupIndex = null;
        if (popover) popover.hidden = true;
        sync();
        if (restoreFocus && previous !== null) points[previous]?.focus({ preventScroll: true });
      };
      const positionPopover = () => {
        if (!popover || popupIndex === null || !mobile.matches) return;
        const photo = popover.parentElement.getBoundingClientRect();
        const viewportTop = window.visualViewport?.offsetTop || 0;
        const viewportBottom = viewportTop + (window.visualViewport?.height || window.innerHeight);
        const start = Math.max(12, viewportTop + 12 - photo.top);
        const end = Math.min(photo.height - 12, viewportBottom - 12 - photo.top);
        popover.style.maxHeight = `${Math.max(64, end - start)}px`;
        const height = popover.offsetHeight;
        const preferred = popupIndex === 0 ? 12 : photo.height - height - 12;
        popover.style.top = `${Math.max(12, Math.min(photo.height - height - 12, Math.max(start, Math.min(preferred, end - height))))}px`;
        popover.style.bottom = 'auto';
      };
      const openFeature = (index, announce) => {
        const selected = features[index];
        if (!selected) return;
        features.forEach((detail) => { detail.open = detail === selected; });
        sync();
        if (announce) announcements.forEach((item) => { item.hidden = Number(item.dataset.wqStorageAnnouncement) !== index; });
      };
      points.forEach((point) => {
        point.addEventListener('click', () => {
          const index = Number(point.dataset.wqStoragePoint);
          if (mobile.matches && popover) {
            if (popupIndex === index) { closePopover(); return; }
            popupIndex = index;
            popoverContents.forEach((content, contentIndex) => { content.hidden = contentIndex !== index; });
            popover.setAttribute('aria-labelledby', popoverContents[index].querySelector('h3').id);
            popover.dataset.placement = index === 0 ? 'top' : 'bottom';
            popover.hidden = false;
            positionPopover();
          }
          openFeature(index, true);
        }, { signal: controller.signal });
      });
      root.querySelector('[data-wq-storage-close]')?.addEventListener('click', () => closePopover(true), { signal: controller.signal });
      root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && popupIndex !== null) { event.preventDefault(); closePopover(true); }
      }, { signal: controller.signal });
      document.addEventListener('click', (event) => {
        if (popupIndex !== null && !popover.contains(event.target) && !points.some((point) => point.contains(event.target))) closePopover();
      }, { signal: controller.signal });
      mobile.addEventListener('change', () => closePopover(popover?.contains(document.activeElement)), { signal: controller.signal });
      window.addEventListener('resize', positionPopover, { signal: controller.signal });
      features.forEach((detail) => {
        detail.addEventListener('toggle', () => {
          if (detail.open) features.forEach((other) => { if (other !== detail) other.open = false; });
          sync();
        }, { signal: controller.signal });
      });
      sync();
      root.classList.toggle('has-inline-details', Boolean(popover && points.length));
      root.classList.add('is-enhanced');
      instances.set(root, () => {
        controller.abort();
        if (popover) popover.hidden = true;
        root.classList.remove('is-enhanced');
        root.classList.remove('has-inline-details');
        announcements.forEach((item) => { item.hidden = true; });
      });
    };
    const remove = (root) => {
      const destroy = instances.get(root);
      if (destroy) destroy();
      instances.delete(root);
    };
    const init = (scope = document) => {
      instances.forEach((destroy, root) => { if (!root.isConnected) remove(root); });
      if (scope.matches && scope.matches(selector)) mount(scope);
      if (scope.querySelectorAll) scope.querySelectorAll(selector).forEach(mount);
    };
    window.WqHomeStorageDetails = { init };
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      instances.forEach((destroy, root) => { if (event.target === root || event.target.contains(root)) remove(root); });
    });
    window.addEventListener('pagehide', () => instances.forEach((destroy, root) => remove(root)));
    window.addEventListener('pageshow', () => init(document));
    let queued = false;
    const observer = new MutationObserver((records) => {
      const hasRoots = records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))));
      if (!hasRoots || queued) return;
      queued = true;
      queueMicrotask(() => { queued = false; init(document); });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    else init(document);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["woolique-language-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',event=>{
  const form=event.target;
  if(!(form instanceof HTMLFormElement)||!form.matches('.wq-language-form'))return;
  const returnField=form.querySelector('input[name="return_to"]');
  if(!returnField)return;
  const current=new URL(window.location.href);
  if(current.pathname.startsWith('/')&&!current.pathname.startsWith('//')&&!current.pathname.includes('\\')){
    const destination=new URL(current.pathname+current.search+current.hash,current.origin);
    if(destination.origin===current.origin)returnField.value=destination.pathname+destination.search+destination.hash;
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["woolique-newsletter-feedback"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('woolique-newsletter')) {
    customElements.define('woolique-newsletter', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.progress = this.querySelector('[data-newsletter-progress]');
        this.button = this.querySelector('button[type="submit"]');
        this.dialog = this.querySelector('.wl-newsletter-dialog');
        if (!this.form || !this.progress || !this.button || this.controller) return;
        this.intentKey = `woolique:newsletter:${this.form.id}`;
        this.controller = new AbortController();
        const options = { capture: true, signal: this.controller.signal };
        const warmCaptcha = () => {
          if (this.form.dataset.cptcha === 'true' || this.form.dataset.hcaptchaBound === 'true') {
            this.captchaObserver?.disconnect();
            return;
          }
          if (typeof window.Shopify?.captcha?.protect === 'function') {
            window.Shopify.captcha.protect(this.form);
            this.captchaObserver?.disconnect();
          }
        };
        this.form.addEventListener('focusin', warmCaptcha, { signal: this.controller.signal });
        if (typeof IntersectionObserver === 'function') {
          this.captchaObserver = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) warmCaptcha();
          }, { rootMargin: '600px 0px' });
          this.captchaObserver.observe(this.form);
        }
        this.addEventListener('click', event => {
          if (event.target.closest('[data-newsletter-close]')) {
            this.dialog?.close();
            return;
          }
          if (!event.target.closest('button[type="submit"]')) return;
          if (this.pending) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          this.start(event);
        }, options);
        this.form.addEventListener('submit', event => this.start(event), options);
        window.addEventListener('pageshow', event => {
          if (event.persisted) {
            this.reset();
            this.dialog?.close();
          }
        }, { signal: this.controller.signal });
        this.dialog?.addEventListener('close', () => this.button.focus({ preventScroll: true }), { signal: this.controller.signal });
        this.dialog?.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, { signal: this.controller.signal });
        const result = this.querySelector('[data-newsletter-result]');
        const intent = this.readIntent();
        if (result) {
          this.clearIntent();
          requestAnimationFrame(() => {
            if (!this.isConnected) return;
            if (result.hasAttribute('data-newsletter-success') && intent && typeof this.dialog?.showModal === 'function') {
              this.dialog.showModal();
            } else {
              result.focus();
            }
          });
        } else if (intent && location.pathname !== '/challenge' && (intent.path === location.pathname || location.hash === `#${this.form.id}`)) {
          this.clearIntent();
          this.progress.textContent = this.progress.dataset.unconfirmedText;
          this.progress.hidden = false;
        }
      }

      readIntent() {
        try {
          const intent = JSON.parse(sessionStorage.getItem(this.intentKey));
          if (intent?.formId === this.form.id && typeof intent.at === 'number' && Date.now() - intent.at >= 0 && Date.now() - intent.at < 600000) return intent;
          this.clearIntent();
        } catch {}
        return null;
      }

      clearIntent() {
        try { sessionStorage.removeItem(this.intentKey); } catch {}
      }

      start(event) {
        if (this.pending || !this.form.checkValidity()) return;
        if (!navigator.onLine) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.progress.textContent = this.progress.dataset.offlineText;
          this.progress.hidden = false;
          return;
        }
        this.pending = true;
        try { sessionStorage.setItem(this.intentKey, JSON.stringify({ formId: this.form.id, path: location.pathname, at: Date.now() })); } catch {}
        this.form.dataset.submitting = 'true';
        this.button.setAttribute('aria-busy', 'true');
        this.progress.hidden = false;
        this.progress.textContent = this.progress.dataset.pendingText;
        this.querySelectorAll('[data-newsletter-result]').forEach(result => { result.hidden = true; });
        this.delayTimer = setTimeout(() => {
          this.progress.textContent = this.progress.dataset.delayedText;
        }, 15000);
      }

      reset() {
        clearTimeout(this.delayTimer);
        this.pending = false;
        delete this.form.dataset.submitting;
        this.button.removeAttribute('aria-busy');
        this.progress.textContent = '';
        this.progress.hidden = true;
      }

      disconnectedCallback() {
        clearTimeout(this.delayTimer);
        this.captchaObserver?.disconnect();
        this.captchaObserver = null;
        this.controller?.abort();
        this.controller = null;
        this.pending = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["woolique-product-reel-behaviour"] && !Shopify.designMode) return;
  try {
    (() => {
    window.WooliqueProductReels?.destroy();
    const selector = 'body.wq-draft [data-wq-reel]';
    const instances = new Map();
    const events = new AbortController();
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let mutationObserver;
    let scanFrame = 0;
    let resizeTimer = 0;
    let disposed = false;
    let pageSuspended = false;

    class ProductReel {
      constructor(root) {
        this.root = root;
        this.artHero = root.matches('.wq-arthero, .wq-faq-reel');
        this.stage = root.querySelector('[data-reel-stage]');
        this.slides = [...root.querySelectorAll('[data-reel-slide]')];
        this.controls = root.querySelector('[data-reel-controls]');
        this.toggle = root.querySelector('[data-reel-toggle]');
        this.previous = root.querySelector('[data-reel-prev]');
        this.next = root.querySelector('[data-reel-next]');
        this.counter = root.querySelector('[data-reel-counter]');
        this.status = root.querySelector('[data-reel-status]');
        this.current = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
        this.interval = Math.max(5000, Number(root.dataset.interval) || 5000);
        this.listeners = new AbortController();
        this.images = new Map();
        this.cancelImageLoads = new Set();
        this.timer = 0;
        this.pointerTimer = 0;
        this.animation = null;
        this.heroTransition = null;
        this.observer = null;
        this.observerRoot = null;
        this.onScreen = false;
        this.hovered = false;
        this.pointerHeld = false;
        this.heldPointerId = null;
        this.focusPaused = false;
        this.userPaused = false;
        this.reducedHold = reduced.matches;
        this.currentReady = false;
        this.processing = false;
        this.loadingIndex = null;
        this.pending = null;
        this.gesture = null;
        this.suppressClickUntil = 0;
        this.togglePointerIntent = null;
        this.generation = 0;
        this.dead = false;
        this.suspended = pageSuspended;
        this.loadsStarted = 0;
        this.changes = 0;
        if (!this.stage || !this.slides.length || !this.controls || (!this.toggle && root.dataset.reelMinimal !== 'true') || !this.previous || !this.next) throw new Error('Incomplete product reel markup');
        this.slides.forEach((slide, index) => this.showSlide(slide, index === this.current));
        this.controls.hidden = this.slides.length < 2;
        this.root.dataset.reelReady = 'true';
        this.bind();
        this.watchVisibility();
        this.sync();
        this.ensureImage(this.current).then(ready => {
          if (this.dead) return;
          this.currentReady = ready;
          if (!ready) this.showError();
          this.sync();
          this.schedule();
          this.prefetchNext();
        });
      }

      showSlide(slide, active) {
        slide.hidden = !active;
        slide.inert = !active;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      }

      requested() { return !this.userPaused && !this.focusPaused && !this.reducedHold; }

      reasons() {
        const reasons = [];
        if (this.slides.length < 2) reasons.push('single-slide');
        if (this.dead) reasons.push('destroyed');
        if (this.suspended) reasons.push('page-suspended');
        if (this.userPaused) reasons.push('user-paused');
        if (this.focusPaused) reasons.push('focus-paused');
        if (this.reducedHold) reasons.push('reduced-motion');
        if (this.hovered) reasons.push('hover');
        if (this.pointerHeld) reasons.push('pointer');
        if (document.hidden) reasons.push('document-hidden');
        if (!this.onScreen) reasons.push('offscreen');
        if (!this.currentReady) reasons.push('current-image-loading');
        if (this.processing) reasons.push('loading-or-transition');
        return reasons;
      }

      canAdvance() {
        return !this.dead && !this.suspended && this.slides.length > 1 && this.requested() && !this.hovered && !this.pointerHeld && !document.hidden && this.onScreen && this.currentReady;
      }

      clearTimer() { clearTimeout(this.timer); this.timer = 0; }

      schedule() {
        this.clearTimer();
        if (!this.canAdvance() || this.processing) return;
        this.timer = setTimeout(() => {
          this.timer = 0;
          if (this.canAdvance() && !this.processing) this.step(1, 'auto');
        }, this.interval);
      }

      sync() {
        if (this.dead) return;
        const requested = this.requested();
        this.toggle?.setAttribute('aria-label', requested ? this.root.dataset.pauseLabel : this.root.dataset.playLabel);
        const playIcon = this.toggle?.querySelector('[data-reel-play-icon]');
        const pauseIcon = this.toggle?.querySelector('[data-reel-pause-icon]');
        if (playIcon) playIcon.hidden = requested;
        if (pauseIcon) pauseIcon.hidden = !requested;
        if (this.counter) this.counter.textContent = `${this.current + 1} / ${this.slides.length}`;
        if (this.status) this.status.setAttribute('aria-live', requested ? 'off' : 'polite');
        this.root.dataset.reelCurrent = String(this.current);
        this.root.dataset.reelState = this.reasons().join(' ') || 'playing';
      }

      announce() {
        if (!this.status) return;
        this.status.setAttribute('aria-live', 'polite');
        this.status.textContent = (this.root.dataset.statusPattern || '')
          .replace('[index]', String(this.current + 1))
          .replace('[total]', String(this.slides.length))
          .replace('[title]', this.slides[this.current].dataset.title || '');
      }

      showError() {
        this.userPaused = true;
        this.clearTimer();
        this.sync();
        if (this.status) { this.status.setAttribute('aria-live', 'polite'); this.status.textContent = this.root.dataset.errorLabel || ''; }
      }

      ensureImage(index) {
        if (this.images.has(index)) return this.images.get(index).promise;
        const slide = this.slides[index];
        let image = slide.querySelector('[data-reel-image]');
        if (!image) {
          const template = slide.querySelector('template[data-reel-image-template]');
          if (!template) return Promise.resolve(false);
          template.replaceWith(template.content.cloneNode(true));
          image = slide.querySelector('[data-reel-image]');
        }
        if (!image) return Promise.resolve(false);
        const record = { state: 'loading', promise: null };
        this.images.set(index, record);
        this.loadsStarted++;
        record.promise = new Promise(resolve => {
          let finished = false;
          let timeout = 0;
          const finish = ready => {
            if (finished) return;
            finished = true;
            clearTimeout(timeout);
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
            this.cancelImageLoads.delete(cancel);
            record.state = ready ? 'ready' : 'failed';
            resolve(ready);
          };
          const onLoad = () => {
            if (!image.naturalWidth) { finish(false); return; }
            if (typeof image.decode === 'function') image.decode().then(() => finish(true), () => finish(image.complete && image.naturalWidth > 0));
            else finish(true);
          };
          const onError = () => finish(false);
          const cancel = () => finish(false);
          this.cancelImageLoads.add(cancel);
          image.addEventListener('load', onLoad, { once: true });
          image.addEventListener('error', onError, { once: true });
          image.loading = 'eager';
          if (index !== this.current) image.fetchPriority = 'low';
          timeout = setTimeout(() => finish(false), 8000);
          if (image.complete) { if (image.naturalWidth > 0) onLoad(); else if (image.currentSrc || image.getAttribute('src')) finish(false); }
        });
        return record.promise;
      }

      prefetchNext() {
        if (this.dead || this.suspended || this.slides.length < 2 || !this.currentReady || !this.onScreen || document.hidden || this.processing) return;
        this.ensureImage((this.current + 1) % this.slides.length);
      }

      step(direction, source) {
        const base = this.pending?.index ?? this.loadingIndex ?? this.current;
        let index = base;
        let attempts = 0;
        do {
          index = (index + direction + this.slides.length) % this.slides.length;
          attempts++;
        } while (attempts < this.slides.length && this.images.get(index)?.state === 'failed');
        if (this.images.get(index)?.state === 'failed' || (index === this.current && attempts > 1)) { this.showError(); return; }
        this.request(index, source, direction);
      }

      request(index, source, direction = 1) {
        if (this.dead || this.slides.length < 2) return;
        this.clearTimer();
        if (source !== 'auto') { this.userPaused = true; if (!this.artHero) this.cancelAnimation(); }
        this.pending = { index, source, direction };
        this.sync();
        this.process();
      }

      async process() {
        if (this.processing || this.dead) return;
        this.processing = true;
        const generation = this.generation;
        while (this.pending && !this.dead && generation === this.generation) {
          const request = this.pending;
          this.pending = null;
          this.loadingIndex = request.index;
          this.sync();
          const ready = await this.ensureImage(request.index);
          if (this.dead || generation !== this.generation) return;
          if (this.pending) continue;
          if (!ready) { this.showError(); break; }
          if (request.source === 'auto' && !this.canAdvance()) break;
          if (request.index !== this.current) {
            const outgoing = this.slides[this.current];
            if (!this.artHero) this.showSlide(outgoing, false);
            this.current = request.index;
            this.showSlide(this.slides[this.current], true);
            this.currentReady = true;
            this.changes++;
            this.sync();
            if (request.source !== 'auto') this.announce();
            if (this.artHero) await this.animateHeroTransition(outgoing);
            else await this.animateEntrance(request.direction);
            if (this.dead || generation !== this.generation) return;
          }
        }
        this.loadingIndex = null;
        this.processing = false;
        this.sync();
        this.schedule();
        this.prefetchNext();
      }

      animateEntrance(direction) {
        const slide = this.slides[this.current];
        if (reduced.matches || this.suspended || document.hidden || typeof slide.animate !== 'function') return Promise.resolve();
        return new Promise(resolve => {
          try {
            const animation = slide.animate([{ translate: `${direction < 0 ? -8 : 8}px 0`, opacity: .9 }, { translate: '0 0', opacity: 1 }], { duration: 420, easing: 'cubic-bezier(.2,.65,.3,1)', fill: 'none' });
            this.animation = animation;
            const finish = () => { if (this.animation === animation) this.animation = null; resolve(); };
            animation.onfinish = finish;
            animation.oncancel = finish;
          } catch { resolve(); }
        });
      }

      animateHeroTransition(outgoing) {
        const incoming = this.slides[this.current];
        if (reduced.matches || this.suspended || document.hidden || typeof incoming.animate !== 'function') {
          this.showSlide(outgoing, false);
          return Promise.resolve();
        }
        return new Promise(resolve => {
          const animations = [];
          let finished = false;
          const finish = () => {
            if (finished) return;
            finished = true;
            this.showSlide(outgoing, false);
            this.showSlide(incoming, true);
            delete outgoing.dataset.reelOutgoing;
            delete incoming.dataset.reelIncoming;
            animations.forEach(animation => animation.cancel());
            this.heroTransition = null;
            resolve();
          };
          this.heroTransition = { finish };
          outgoing.inert = true;
          outgoing.setAttribute('aria-hidden', 'true');
          outgoing.dataset.reelOutgoing = '';
          incoming.dataset.reelIncoming = '';
          const animate = (element, frames, options) => {
            if (element) animations.push(element.animate(frames, { fill: 'both', ...options }));
          };
          try {
            animate(incoming, [{ opacity: 0 }, { opacity: 1 }], { duration: 1100, easing: 'cubic-bezier(.4,0,.2,1)' });
            animate(incoming.querySelector('[data-reel-image]'), [{ transform: 'scale(1.025)' }, { transform: 'scale(1)' }], { duration: 1250, easing: 'cubic-bezier(.22,.61,.36,1)' });
            animate(outgoing.querySelector('figcaption'), [{ opacity: 1 }, { opacity: 0 }], { duration: 220, easing: 'ease-out' });
            animate(incoming.querySelector('figcaption'), [{ opacity: 0, translate: '0 8px' }, { opacity: 1, translate: '0 0' }], { duration: 620, delay: 260, easing: 'cubic-bezier(.22,.7,.2,1)' });
            Promise.all(animations.map(animation => animation.finished)).then(finish, finish);
          } catch {
            animations.forEach(animation => animation.finished.catch(() => {}));
            finish();
          }
        });
      }

      cancelAnimation() {
        if (this.animation) { this.animation.cancel(); this.animation = null; }
        this.heroTransition?.finish();
      }

      rootForObserver() {
        const wrapper = this.root.closest('.page-wrapper');
        return wrapper && wrapper.clientHeight > 0 && /(auto|scroll)/.test(getComputedStyle(wrapper).overflowY) ? wrapper : null;
      }

      geometricVisibility() {
        const rect = this.root.getBoundingClientRect();
        const bounds = this.observerRoot ? this.observerRoot.getBoundingClientRect() : { top: 0, bottom: innerHeight };
        return rect.width > 0 && rect.height > 0 && Math.min(rect.bottom, bounds.bottom, innerHeight) - Math.max(rect.top, bounds.top, 0) > Math.min(60, rect.height * .15);
      }

      setVisibility(visible) {
        const changed = visible !== this.onScreen;
        this.onScreen = visible;
        if (changed) { this.sync(); this.schedule(); }
        if (visible) this.prefetchNext();
      }

      watchVisibility() {
        this.observer?.disconnect();
        this.observer = null;
        this.observerRoot = this.rootForObserver();
        this.setVisibility(false);
        if (this.dead || this.suspended) return;
        if (typeof IntersectionObserver !== 'function') { this.setVisibility(this.geometricVisibility()); return; }
        const root = this.observerRoot;
        this.observer = new IntersectionObserver(entries => {
          if (this.dead || this.suspended) return;
          if (this.rootForObserver() !== root) { this.watchVisibility(); return; }
          const entry = entries[entries.length - 1];
          this.setVisibility(Boolean(entry?.isIntersecting && this.geometricVisibility()));
        }, { root, threshold: [0, .15, .5] });
        this.observer.observe(this.root);
      }

      bind() {
        const signal = this.listeners.signal;
        this.previous.addEventListener('click', () => this.step(-1, 'manual'), { signal });
        this.next.addEventListener('click', () => this.step(1, 'manual'), { signal });
        this.toggle?.addEventListener('pointerdown', () => { this.togglePointerIntent = !this.requested(); }, { signal });
        this.toggle?.addEventListener('pointercancel', () => { this.togglePointerIntent = null; }, { signal });
        this.toggle?.addEventListener('click', () => {
          const play = this.togglePointerIntent ?? !this.requested();
          this.togglePointerIntent = null;
          this.userPaused = !play;
          if (play) { this.focusPaused = false; this.reducedHold = false; }
          this.sync();
          this.schedule();
        }, { signal });
        this.root.addEventListener('focusin', () => { this.focusPaused = true; if (!this.artHero) this.cancelAnimation(); this.sync(); this.clearTimer(); }, { signal });
        this.root.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); this.clearTimer(); } }, { signal });
        this.root.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { this.hovered = false; this.sync(); this.schedule(); } }, { signal });
        this.root.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.step(event.key === 'ArrowLeft' ? -1 : 1, 'keyboard'); }
        }, { signal });
        this.stage.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          clearTimeout(this.pointerTimer);
          this.pointerHeld = true;
          this.heldPointerId = event.pointerId;
          this.clearTimer();
          this.sync();
          if (event.pointerType === 'touch' || event.pointerType === 'pen') this.gesture = { id: event.pointerId, x: event.clientX, y: event.clientY };
        }, { passive: true, signal });
        this.stage.addEventListener('pointermove', event => {
          const gesture = this.gesture;
          if (gesture?.id === event.pointerId && Math.abs(event.clientY - gesture.y) > 12 && Math.abs(event.clientY - gesture.y) > Math.abs(event.clientX - gesture.x)) this.gesture = null;
        }, { passive: true, signal });
        document.addEventListener('pointerup', event => {
          if (event.pointerId !== this.heldPointerId) return;
          this.heldPointerId = null;
          const gesture = this.gesture;
          this.gesture = null;
          if (gesture?.id === event.pointerId) {
            const dx = event.clientX - gesture.x;
            const dy = event.clientY - gesture.y;
            if (Math.abs(dx) >= Math.max(36, this.stage.clientWidth * .12) && Math.abs(dx) > Math.abs(dy) * 1.5) {
              this.suppressClickUntil = performance.now() + 450;
              this.step(dx < 0 ? 1 : -1, 'swipe');
            }
          }
          clearTimeout(this.pointerTimer);
          this.pointerTimer = setTimeout(() => { this.pointerHeld = false; this.sync(); this.schedule(); }, 300);
        }, { passive: true, signal });
        document.addEventListener('pointercancel', event => {
          if (event.pointerId !== this.heldPointerId) return;
          this.heldPointerId = null;
          this.gesture = null;
          this.pointerHeld = false;
          this.sync();
          this.schedule();
        }, { passive: true, signal });
        this.stage.addEventListener('click', event => {
          if (performance.now() < this.suppressClickUntil) { this.suppressClickUntil = 0; event.preventDefault(); event.stopPropagation(); }
        }, { capture: true, signal });
      }

      preferenceChanged() {
        if (reduced.matches) { this.reducedHold = true; this.cancelAnimation(); }
        this.sync();
        this.schedule();
      }

      documentVisibilityChanged() {
        if (document.hidden) this.cancelAnimation();
        this.sync();
        this.schedule();
        this.prefetchNext();
      }

      suspend() { this.suspended = true; this.clearTimer(); this.cancelAnimation(); this.observer?.disconnect(); this.sync(); }
      resume() { this.suspended = false; this.watchVisibility(); this.sync(); this.schedule(); }

      diagnostics() {
        return {
          id: this.root.id || this.root.closest('.shopify-section')?.id || null,
          count: this.slides.length,
          current: this.current,
          title: this.slides[this.current]?.dataset.title,
          userPaused: this.userPaused,
          focusPaused: this.focusPaused,
          reduced: reduced.matches,
          reasons: this.reasons(),
          timer: Boolean(this.timer),
          interval: this.interval,
          loading: this.processing,
          loadingIndex: this.loadingIndex,
          queuedIndex: this.pending?.index ?? null,
          imagesInstantiated: this.slides.filter(slide => slide.querySelector('[data-reel-image]')).length,
          imageLoadsStarted: this.loadsStarted,
          imageStates: [...this.images].map(([index, image]) => ({ index, state: image.state })),
          changes: this.changes,
          observerRoot: this.observerRoot ? 'page-wrapper' : 'viewport',
          onScreen: this.onScreen,
          suspended: this.suspended,
          destroyed: this.dead
        };
      }

      destroy() {
        this.dead = true;
        this.generation++;
        this.pending = null;
        this.clearTimer();
        clearTimeout(this.pointerTimer);
        this.cancelAnimation();
        this.observer?.disconnect();
        this.listeners.abort();
        for (const cancel of this.cancelImageLoads) cancel();
        this.controls.hidden = true;
        delete this.root.dataset.reelReady;
      }
    }

    function scan() {
      scanFrame = 0;
      if (disposed) return;
      for (const [root, reel] of instances) if (!root.isConnected) { reel.destroy(); instances.delete(root); }
      document.querySelectorAll(selector).forEach(root => {
        if (instances.has(root)) return;
        try { instances.set(root, new ProductReel(root)); }
        catch { const controls = root.querySelector('[data-reel-controls]'); if (controls) controls.hidden = true; root.dataset.reelReady = 'static'; }
      });
    }

    function scheduleScan() { if (!scanFrame && !disposed) scanFrame = requestAnimationFrame(scan); }
    function destroyWithin(container) { for (const [root, reel] of instances) if (container.contains(root)) { reel.destroy(); instances.delete(root); } }
    function start() {
      if (disposed) return;
      scan();
      if (!mutationObserver && document.body) {
        mutationObserver = new MutationObserver(records => {
          if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('[data-wq-reel]') || node.querySelector('[data-wq-reel]'))))) scheduleScan();
        });
        mutationObserver.observe(document.body, { childList: true, subtree: true });
      }
    }
    function destroy() {
      disposed = true;
      cancelAnimationFrame(scanFrame);
      clearTimeout(resizeTimer);
      mutationObserver?.disconnect();
      events.abort();
      instances.forEach(reel => reel.destroy());
      instances.clear();
    }

    reduced.addEventListener('change', () => instances.forEach(reel => reel.preferenceChanged()), { signal: events.signal });
    document.addEventListener('visibilitychange', () => instances.forEach(reel => reel.documentVisibilityChanged()), { signal: events.signal });
    document.addEventListener('shopify:section:load', scheduleScan, { signal: events.signal });
    document.addEventListener('shopify:section:unload', event => destroyWithin(event.target), { signal: events.signal });
    document.addEventListener('shopify:section:select', event => instances.forEach((reel, root) => { if (event.target.contains(root)) { reel.userPaused = true; reel.sync(); reel.clearTimer(); } }), { signal: events.signal });
    window.addEventListener('resize', () => { clearTimeout(resizeTimer); resizeTimer = setTimeout(() => instances.forEach(reel => reel.watchVisibility()), 140); }, { passive: true, signal: events.signal });
    document.addEventListener('scroll', () => { if (typeof IntersectionObserver !== 'function') instances.forEach(reel => reel.setVisibility(reel.geometricVisibility())); }, { passive: true, capture: true, signal: events.signal });
    window.addEventListener('pagehide', () => { pageSuspended = true; instances.forEach(reel => reel.suspend()); }, { signal: events.signal });
    window.addEventListener('pageshow', () => { pageSuspended = false; start(); instances.forEach(reel => reel.resume()); }, { signal: events.signal });
    window.WooliqueProductReels = { get states() { return [...instances.values()].map(reel => reel.diagnostics()); }, diagnostics: () => ({ count: instances.size, suspended: pageSuspended, states: [...instances.values()].map(reel => reel.diagnostics()) }), refresh: scheduleScan, destroy };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true, signal: events.signal });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
